<div class="modal-header">
  <div class="row">
    <div class="col-md-2">
      <fa-icon [icon]="['fas', 'exclamation-triangle']"
               class="text-warning"
               style="font-size: 3.5em"></fa-icon>
    </div>
    <div class="col-md-10">
      <b class="text-warning">Are you sure you want to put the device in lost mode?</b>
    </div>
  </div>
</div>
<div class="modal-body">
  <form id="lostModeForm"
        [formGroup]="lostModeForm"
        (ngSubmit)="enableLostMode()">
    <div>
      <label class="form-label"
             for="message">Message:</label>
      <input id="message"
             formControlName="message"
             required="true"
             class="form-control" />
    </div>
    <div>
      <label class="form-label"
             for="footnote">Footnote:</label>
      <input id="footnote"
             formControlName="footnote"
             required="false"
             class="form-control"
             placeholder="This iPad has been reported as lost/stolen. Please bring it to an ambassador in the nearest citizenM hotel." />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-warning me-1"
          type="submit"
          form="lostModeForm"
          [disabled]="!lostModeForm.valid">
    Enable Lost Mode
  </button>
  <button class="btn btn-primary"
          data-dismis="modal"
          (click)="activeModal.close()">Cancel</button>
</div>